<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "GLOBAL_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
                <button (click)="onBtnExport()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-download"></i> Download CSV </button>
                <button (click)="copy()" class="btn btn-warning"> <i aria-hidden="true" class="fa fa-copy"></i> Copy </button>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->
  
    <!-- GRILLA -->
    <ng-template #enviarTemplateEdit>
        <div class="form-group col-md-12">
            <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter />
        </div>
        <br>
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                            [id]    ="DAT_AG_GRID.id" 
                            [class] ="DAT_AG_GRID.class" 
                            [ngStyle]="DAT_AG_GRID.style" 
                            [rowData]="rowData" 
                            [rowSelection] = 'rowSelection'
                            [columnDefs]="columnDefs"
                            [pagination]="DAT_AG_GRID.pagination" 
                            [paginationPageSize]="DAT_AG_GRID.pagina"
                            [allowContextMenuWithControlKey]="true"
                            [defaultColDef]="defaultColDef"
                            [suppressExcelExport]="true"
                            [copyHeadersToClipboard]=" true"
                            [enableRangeSelection]=" true"
                            [frameworkComponents]="frameworkComponents" >
        </ag-grid-angular>

    </ng-template>
    <!-- GRILLA -->
  </div>